export type NavTarget = "about" | "fragments" | "contact";

export const NAV_ITEMS: Array<{ label: string; target: NavTarget }> = [
  { label: "ABOUT", target: "about" },
  // FRAGMENTS tab temporarily hidden — section is on hold, see Subpage/index.tsx
  // { label: "FRAGMENTS", target: "fragments" },
  { label: "CONTACT", target: "contact" },
];
